import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { Spinner } from 'flowbite-react'
import axios from 'axios'
import UserNavbar from '../Components/UserNavbar'
import CourseCard from '../Components/CourseCard'
import PortfolioExperience from '../Components/PortfolioExperience'
import PortfolioEducation from '../Components/PortfolioEducation'

export default function Portfolio() {

const pathParam=useParams()
const [loading, setLoading] = useState(true)
const [data, setData] = useState(
    {
        "user_id": 3,
        "email": "leena@gmail.com",
        "phone": "0123456789",
        "name": "Leena",
        "name_bangla": "লিনা",
        "user_type": "General",
        "user_type_bangla": "সাধারন",
        "institute": "",
        "institute_bangla": "",
        "address": "123 narayanganj, dhaka",
        "address_bangla": "১২৩ নারায়ণগঞ্জ ঢাকা",
        "image": "https://i.postimg.cc/Jhzkj5cj/image.png"
    }
)
const [lan, setLan] = useState('bangla')
const baseURL = "https://mukti-backend-bd.onrender.com"
const getData = async () => {
    try {
        // const res = await axios.get(`${baseURL}/userid/${pathParam.id}`)
        // console.log(res.data)
        // setData(res.data)
        setLoading(false)
    } catch (e) {
        console.log(e)
    }
}
useEffect(() => {
    if (localStorage.getItem('language') === 'english') {
        setLan('english')
    } else {
        setLan('bangla')
    }
    getData()
}, [])
  return loading? <Spinner/>:(
    <div className="row ">
            <UserNavbar name={data.name} name_bangla={data.name_bangla}/>
           
            <div class="bg-white bg-pink-200 dark:bg-gray-900">
                <div class="gap-8 h-screen items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
                    
                    <div class="mt-4 md:mt-0">
                       {lan==='english' && <h2 class="mb-4 text-center md:text-left text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white"> I am <span class="text-pink-600 dark:text-pink-500">{data.name}, </span> an intersex person </h2>}
                       {lan==='bangla' && <h2 class="mb-4 text-center md:text-left text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">আমি<span class="text-pink-600 dark:text-pink-500"> {data.name_bangla} </span> একজন ইন্টারসেক্স ব্যক্তি</h2>}
                       {lan=="english" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">Mukti has helped me become a better version of myself</p>}
                       {lan=="bangla" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">মুক্তি আমাকে নিজের একটি ভাল সংস্করণ হতে সাহায্য করেছে</p>}
                       
                    </div>
                    <img class="w-full hidden dark:block" src={data.image} alt="dashboard image" />
                </div>
            </div>

            <section class="bg-white dark:bg-gray-900">
                <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
                    <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
                        {lan=="english" && <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">My Work Experience</h2>}
                        {lan=="bangla" && <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">আমার কাজের অভিজ্ঞতা</h2>}
                        {lan=="english" && <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">These are the organizations that I've worked with</p>}
                        {lan=="bangla" && <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">আমি যেসকল সংস্থার সাথে কাজ করেছি</p>}
                    </div>
                    <div class=" grid items-center justify-center gap-8 mb-6 lg:mb-16 md:grid-cols-1">
                        <PortfolioExperience user_id={pathParam.id}/>
                       
                    </div>
                </div>
            </section>
            <section class="bg-white dark:bg-gray-900">
                <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
                    <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
                        {lan=="english" && <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">My Educational Background</h2>}
                        {lan=="bangla" && <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">আমার শিক্ষাগত যোগ্যতা</h2>}
                        {lan=="english" && <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">There are the certificates that I have acquired</p>}
                        {lan=="bangla" && <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">আমি অর্জন করেছি যে সার্টিফিকেট</p>}
                    </div>
                    <div class="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">
                        <PortfolioEducation user_id={pathParam.id}/>
                       
                    </div>
                </div>
            </section>

            <section class="bg-white dark:bg-gray-900">
                <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
                    <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
                        {lan=="english" && <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">My Completed Courses</h2>}
                        {lan=="bangla" && <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">আমি যে কোর্সগুলো নিয়েছি</h2>}
                        {lan=="english" && <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">I have gained these skills with the support of mukti</p>}
                        {lan=="bangla" && <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">আমি মুক্তির সহায়তায় এই দক্ষতা অর্জন করেছি</p>}
                    </div>
                    <div class="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">
                    <div class="items-center py-8 px-4 ">
                        <div class="max-w-sm bg-white border border-gray-500 rounded-lg shadow-lg dark:bg-gray-700 dark:border-gray-700">
                            {lan=="english" && <h5 class="mt-4 text-2xl text-center font-bold tracking-tight text-gray-900 dark:text-white">TRACK 2</h5>}
                            {lan=="bangla" && <h5 class="mt-4 text-2xl text-center font-bold tracking-tight text-gray-900 dark:text-white">ট্র্যাক 2</h5>}
                        {lan=="english" && <h5 class="mb-4 text-3xl text-center font-bold tracking-tight text-gray-900 text-primary-500">MS Office</h5>}
                        {lan=="bangla" && <h5 class="mb-4 text-3xl text-center font-bold tracking-tight text-gray-900 text-primary-500">মাইক্রোসফট অফিস</h5>}

                            <img class="w-full mb-8" src="https://www.online-tech-tips.com/wp-content/uploads/2022/08/ms-office.jpeg" alt="" />


                        </div>
                        </div>
                       
                    </div>
                </div>
            </section>

    
        </div>
  )
}
